export const SOCIAL_SIGNUP_COOKIE = 'is_social_signup';
